import EcoVideo from 'eco-design/base/eco-video';
import EcoSpace from 'eco-design/base/eco-space';
import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import { useRouter } from 'next/router';

const E: React.FC = () => {
    const { t } = useLang('ats.E');
    const { isPad, isH5 } = useDeviceDetect();
    const { locale = '' } = useRouter();
    /** 动画 */
    const infoRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const label = infoRef.current?.querySelector('.label');
        const title = infoRef.current?.querySelector('.title');
        const desc = infoRef.current?.querySelector('.desc');
        const video = document?.querySelector('.smart-gateway-E .eco-video');
        const ani1 = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                label?.classList.add('enter');
                title?.classList.add('enter');
                desc?.classList.add('enter');
                video?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    label?.classList.remove('enter');
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                    video?.classList.remove('enter');
                }
            },
        });
        const ani2 = AniContainer.create({
            triggerElement: '.smart-gateway-C',
            triggerHook: 1,
            onEnter: () => !video && setVideo('https://websiteoss.ecoflow.com/upload/video/1760095758922/01_Ready_1.mp4'),
        });
        // const ani3 = AniContainer.create({
        //     triggerElement: `.${css.section} .video-box`,
        //     triggerHook: 1,
        //     offset: '30%',
        //     onEnter: () => {
        //         const video: HTMLVideoElement | null = document.querySelector(`.${css.section} video`);
        //         console.log('video', video);
        //         if (video) {
        //             video.currentTime = 0;
        //             video.play();
        //         }
        //     },
        // });
        return () => {
            ani1.destroy?.();
            ani2.destroy?.();
            // ani3.destroy?.();
        };
    }, []);
    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} smart-gateway-E GtmModuleData-section`}
                id="smart-gateway-E"
                data-section-id={'smart-gateway-E'}
                data-section-title={t('title')}
            >
                <div className="info" ref={infoRef}>
                    <div className="left">
                        <div className="label ani-1">{t('label')}</div>
                        <div className="title ani-2">{t('title')}</div>
                    </div>
                    <div className="desc right ani-2-5">
                        {t.rich('desc', {
                            white: (a: string) => {
                                return <span className="white">{a}</span>;
                            },
                        })}
                    </div>
                </div>
                <div className="Video video-box">
                    {/* {video && ( */}
                    <EcoVideo
                        className="ani-3"
                        pc={'https://websiteoss.ecoflow.com/upload/video/1760095758922/01_Ready_1.mp4'}
                        loop
                        autoPlay
                        // poster="https://websiteoss.ecoflow.com/upload/image/1754397510191/4-pc.jpg"
                        aria-label={t('title')}
                    />
                    {/* )} */}
                    <img
                        className="sub-img"
                        src={
                            isPad || isH5
                                ? 'https://websiteoss.ecoflow.com/upload/image/1760178248230/m_%E9%A3%8E%E6%9A%B4%E9%80%9A%E7%9F%A5.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1760178236433/pc_%E9%A3%8E%E6%9A%B4%E9%80%9A%E7%9F%A5.jpg'
                        }
                        loading="lazy"
                        draggable="false"
                    />
                </div>
                {locale === 'us' && <div className="section-tips">{t('tips')}</div>}
            </section>
        </>
    );
};

export default E;
